<sync-icon iconSize="small" name="lock-encrypted"></sync-icon>
<div class="title">Secured by Sync</div>
<div class="body-2">Your file data stored in the cloud is encrypted and secure.</div>